import { render, staticRenderFns } from "./ValidationMessages.vue?vue&type=template&id=0a6a291a&"
import script from "./ValidationMessages.vue?vue&type=script&lang=js&"
export * from "./ValidationMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports